import React from 'react';
import { ReactComponent as Icon } from '../../../assets/icon-arrow-right.svg';
import createSvgIcon from '../../../shared/utils/create-svg-icon';

export const ArrowRightIcon = createSvgIcon(<Icon />, 'ArrowRightIcon');
